'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AssistiveText = require('./../AssistiveText');

var _AssistiveText2 = _interopRequireDefault(_AssistiveText);

var _markerIcon = require('./markerIcon');

var _markerIcon2 = _interopRequireDefault(_markerIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ICON_DESCRIPTION = 'marker icon';

function Icon(_ref) {
  var icon = _ref.icon;

  if (icon) {
    return icon;
  }

  return _react2["default"].createElement('span', {
    className: 'rainbow-google-map-marker_icon',
    title: ICON_DESCRIPTION
  }, _react2["default"].createElement(_markerIcon2["default"], null), _react2["default"].createElement(_AssistiveText2["default"], {
    text: ICON_DESCRIPTION
  }));
}

Icon.propTypes = {
  icon: _propTypes2["default"].node
};
Icon.defaultProps = {
  icon: null
};